// import { FirebaseDataService } from "../../../../services/firebase-data.service";
import { getDataFromMongoDb } from "../../../../services/mongod.data";

// const firebaseDataService = new FirebaseDataService();

function graphPersonaCoupons(statsObj, user, graph, chartType = 'barchart') {
  return new Promise(async (resolve, reject) => {
    try {
      let graph_result_data = {}
      var grapLabel = null

      const mongoResponse = await getDataFromMongoDb(user, graph);

      if (mongoResponse && mongoResponse.data) {
        console.log("Fetched persona data mongo:", mongoResponse);
        const dataArray = Object.entries(mongoResponse.data)

        dataArray.forEach(([key, item]) => {
          if (key === 'graph-options') {
            grapLabel = JSON.parse(JSON.stringify(item));
          } else {
            let year_key = key
            let year_data = JSON.parse(JSON.stringify(item))

            for (let [month_key, month_data] of Object.entries(year_data)) {
              for (let [week_key, week_data] of Object.entries(month_data)) {
                let data_label_key = parseInt(year_key) * 10000 + parseInt(month_key) * 100 + parseInt(week_key)
                graph_result_data[data_label_key] = week_data
              }
            }
          }
        })

        resolve([graph_result_data]);
      } else {
        resolve([{}]);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function fetchGraphPersonaNudgeCoupon(statsObj, user, graph) {
  return new Promise(async (resolve, reject) => {
    try {
      // Original FirebaseDataService implementation (commented out)
      // firebaseDataService.graphPersonaCoupons(statsObj, user, graph).subscribe((data) => {
      //   resolve({ data });
      // });

      // New direct implementation
      const data = await graphPersonaCoupons(statsObj, user, graph);
      resolve({ data });
    } catch (error) {
      reject(error);
    }
  });
}

// Helper function to format nudge-wise data from Firebase
function buildNudgeWiseWeekMap(data) {
  const result = {};

  if (!data || typeof data !== "object") return result;

  Object.entries(data).forEach(([year, monthsObj]) => {
    if (!monthsObj || typeof monthsObj !== "object") return;

    Object.entries(monthsObj).forEach(([month, daysObj]) => {
      if (!daysObj || typeof daysObj !== "object") return;

      Object.entries(daysObj).forEach(([day, dayData]) => {
        const key = `${year}-${month}-${day}`;
        result[key] = Array.isArray(dayData) ? dayData : [];
      });
    });
  });

  return result;
}

// Fetch nudge-wise performance data from Firebase
export function fetchNudgeWisePerformance(statsObj, user, graph) {
  return new Promise(async (resolve, reject) => {
    try {
      const mongoResponse = await getDataFromMongoDb(user, graph);

      if (mongoResponse && mongoResponse.data) {
        // mongoResponse.data is formatted as [year_string, {year_data_object}]
        // Extract the actual year data object (index 1)
        const yearDataObject = Array.isArray(mongoResponse.data) 
          ? mongoResponse.data[1] 
          : mongoResponse.data;

        const formattedData = buildNudgeWiseWeekMap(yearDataObject);
        const availableWeeks = Object.keys(formattedData).sort((a, b) => b.localeCompare(a));

        resolve({
          data: formattedData,
          weeks: availableWeeks
        });
      }
    } catch (error) {
      console.error("Error fetching nudge-wise performance:", error);
      reject(error);
    }
  });
}
